

export const SALESFORCE = {
    SALESFORCE_CLIENT_ID: process.env.REACT_APP_SALESFORCE_CLIENT_ID,
    SALESFORCE_SANBOX_CLIENT_ID: process.env.REACT_APP_SALESFORCE_SANDBOX_CLIENT_ID,
}

export const ENVIRONMENTS = {
    Production: SALESFORCE.SALESFORCE_CLIENT_ID,
    Sandbox: SALESFORCE.SALESFORCE_SANBOX_CLIENT_ID
}

export const DEFAULT_ENVIRONMENTS = 'Production'




// WEBPACK FOOTER //
// ./src/sub-projects/salesforce/constants/index.tsx